import {
  STATUS_AUTHORIZED,
  STATUS_REFUSED,
  STATUS_SETTLED,
  STATUS_CANCELLED,
  STATUS_REFUNDED,
  STATUS_PARTIALLY_REFUNDED,
  STATUS_FAILED,
  STATUS_EXPIRED,
  STATUS_SUCCESS,
} from 'pages/Transactions/helpers';
import {
  STATUS_PAID,
  STATUS_INITIATED,
  STATUS_PROCESSED,
  STATUS_IN_TRANSIT,
} from 'pages/Payouts/helpers';
import {
  STATUS_PENDING,
  STATUS_RUNNING,
  STATUS_SKIPPED,
  STATUS_COMPLETED,
} from 'pages/Webhooks/helpers';
import {
  INFORMATION_REQUESTED,
  NOTIFICATION_RECEIVED,
  FIRST_CHARGEBACK,
  DEFENSE_DECLINED,
  DEFENSE_ACCEPTED,
  WON,
  LOST,
  CHARGE_REFUNDED,
  UNDER_REVIEW,
  NEEDS_RESPONSE,
  CLOSED,
  EVIDENCE_SUBMITTED,
} from 'pages/Disputes/helpers';
import { STATUS_ACTIVE } from 'pages/Clients/helpers';
import {
  STATUS_INACTIVE,
  STATUS_NA,
  STATUS_SUSPENDED,
} from 'pages/Companies/helpers';

const PENDING = {
  icon: ['far', 'hourglass'],
  color: 'neutral',
};
const SUCCESS = {
  icon: 'check',
  color: 'success',
};
const DANGER = {
  icon: 'times',
  color: 'danger',
};
const WARNING = {
  icon: 'undo',
  color: 'warning',
};
const CANCELLED = {
  icon: 'times',
  color: 'neutral',
};

export const BADGE_ICON = {
  [STATUS_AUTHORIZED]: SUCCESS.icon,
  [STATUS_SETTLED]: SUCCESS.icon,
  [STATUS_PAID.toLowerCase()]: SUCCESS.icon,
  [STATUS_COMPLETED]: SUCCESS.icon,
  [STATUS_SUCCESS]: SUCCESS.icon,
  [DEFENSE_ACCEPTED]: SUCCESS.icon,
  [WON]: SUCCESS.icon,
  [STATUS_ACTIVE]: SUCCESS.icon,
  [CLOSED]: SUCCESS.icon,

  [STATUS_REFUSED]: DANGER.icon,
  [STATUS_FAILED]: DANGER.icon,
  [STATUS_EXPIRED]: DANGER.icon,
  [DEFENSE_DECLINED]: DANGER.icon,
  [LOST]: DANGER.icon,

  [STATUS_REFUNDED]: WARNING.icon,
  [STATUS_PARTIALLY_REFUNDED]: WARNING.icon,
  [CHARGE_REFUNDED]: WARNING.icon,
  [FIRST_CHARGEBACK]: WARNING.icon,

  [STATUS_INITIATED.toLowerCase()]: PENDING.icon,
  [STATUS_PROCESSED.toLowerCase()]: PENDING.icon,
  [STATUS_PENDING]: PENDING.icon,
  [STATUS_IN_TRANSIT.toLowerCase()]: PENDING.icon,
  [NEEDS_RESPONSE]: PENDING.icon,
  [UNDER_REVIEW]: PENDING.icon,
  [NOTIFICATION_RECEIVED]: PENDING.icon,
  [INFORMATION_REQUESTED]: PENDING.icon,
  [STATUS_RUNNING]: PENDING.icon,
  [EVIDENCE_SUBMITTED]: PENDING.icon,

  [STATUS_CANCELLED]: CANCELLED.icon,
  [STATUS_SKIPPED]: CANCELLED.icon,
  [STATUS_INACTIVE]: WARNING.icon,
  [STATUS_NA]: PENDING.icon,
  [STATUS_SUSPENDED]: DANGER.icon,
};
export const BADGE_COLOR = {
  [STATUS_AUTHORIZED]: SUCCESS.color,
  [STATUS_SETTLED]: SUCCESS.color,
  [STATUS_PAID.toLowerCase()]: SUCCESS.color,
  [STATUS_COMPLETED]: SUCCESS.color,
  [STATUS_SUCCESS]: SUCCESS.color,
  [DEFENSE_ACCEPTED]: SUCCESS.color,
  [WON]: SUCCESS.color,
  [STATUS_ACTIVE]: SUCCESS.color,
  [CLOSED]: SUCCESS.color,

  [STATUS_REFUSED]: DANGER.color,
  [STATUS_FAILED]: DANGER.color,
  [STATUS_EXPIRED]: DANGER.color,
  [DEFENSE_DECLINED]: DANGER.color,
  [LOST]: DANGER.color,

  [STATUS_REFUNDED]: WARNING.color,
  [STATUS_PARTIALLY_REFUNDED]: WARNING.color,
  [CHARGE_REFUNDED]: WARNING.color,
  [FIRST_CHARGEBACK]: WARNING.color,

  [STATUS_INITIATED.toLowerCase()]: PENDING.color,
  [STATUS_PROCESSED.toLowerCase()]: PENDING.color,
  [STATUS_PENDING]: PENDING.color,
  [STATUS_IN_TRANSIT.toLowerCase()]: PENDING.color,
  [NEEDS_RESPONSE]: PENDING.color,
  [UNDER_REVIEW]: PENDING.color,
  [NOTIFICATION_RECEIVED]: PENDING.color,
  [INFORMATION_REQUESTED]: PENDING.color,
  [STATUS_RUNNING]: PENDING.color,
  [EVIDENCE_SUBMITTED]: PENDING.color,

  [STATUS_CANCELLED]: CANCELLED.color,
  [STATUS_SKIPPED]: CANCELLED.color,
  [STATUS_INACTIVE]: WARNING.color,
  [STATUS_NA]: PENDING.color,
  [STATUS_SUSPENDED]: DANGER.color,
};
